var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_9067)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.966,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.632812 -0.015625C2.10742 -0.015625 3.58204 -0.015625 5.05664 -0.015625C6.29678 1.81989 7.55165 3.64604 8.82129 5.46289C10.3948 3.64045 11.9622 1.81429 13.5234 -0.015625C13.9726 -0.015625 14.4219 -0.015625 14.8711 -0.015625C13.0554 2.10294 11.239 4.22208 9.42188 6.3418C11.3953 9.22317 13.3679 12.1041 15.3398 14.9844C13.8652 14.9844 12.3906 14.9844 10.916 14.9844C9.59924 13.0473 8.27602 11.1137 6.94629 9.18359C5.28486 11.1134 3.62959 13.047 1.98047 14.9844C1.53125 14.9844 1.08203 14.9844 0.632812 14.9844C2.53135 12.7586 4.43563 10.5369 6.3457 8.31934C4.44489 5.53813 2.54061 2.7598 0.632812 -0.015625ZM2.44922 1.00977C3.09874 0.970845 3.75305 0.970845 4.41211 1.00977C7.43839 5.35827 10.4755 9.6991 13.5234 14.0322C12.8689 14.0566 12.2146 14.0517 11.5605 14.0176C8.52278 9.67971 5.48566 5.34377 2.44922 1.00977Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_9067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5cf0d42216863c4bf4c063ef173fc511.svg";
export { ForwardRef as ReactComponent };